<template>
  <div class="row">
    <div class="col-11 mx-auto">
      <div class="w-100 bg-secondary-1 rounded py-2 px-5">
        <div class="row">
          <div class="col-12 col-md-3 my-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">Tipo:</label>
            <span>Cambio de Estatus</span>
          </div>
          <div class="col-12 col-md-2 my-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">Usuario:</label>
            <span>{{ data.userName }}</span>
          </div>
          <div class="col-12 col-md-4 my-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">Nombre:</label>
            <span>{{ data.name }}</span>
          </div>
          <div class="col-12 col-md-3 my-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">Estatus:</label>
            <span class="d-flex align-items-baseline">
              <div
                class="status-indicator"
                :style="{ backgroundColor: data.newStatus.color }"
              >
                &nbsp;
              </div>
              <span>{{ data.newStatus.text }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-11 mx-auto mt-3">
      <div class="row d-flex justify-content-between my-3 px-2">
        <div class="tag-badge ">
          <span class="dot text-center pl-1 d-flex align-items-center">
            <i
              :class="'fa fa-history'"
              class="text-orange orange-icon-badge-align"
            />
          </span>
          <span class="tag-badge-title text-black py-1 pl-2 line-height">
            Historial de Consulta
          </span>
        </div>
      </div>
      <div class="row">
        <div
          v-for="(meeting, index) in filteredItems"
          :key="index"
          class="col-12 mb-2"
        >
          <div class="w-100 bg-secondary-3 rounded py-2 px-5">
            <div class="row">
              <div class="col-12 col-md-4 my-2 flex-column d-flex">
                <label class="mb-0 color-gray-6 text-small">
                  Tipo de Reunión:
                </label>
                <span>{{ meeting.typeMeeting.name }}</span>
              </div>

              <div class="col-12 col-md-4 my-2 flex-column d-flex">
                <label class="mb-0 color-gray-6 text-small">Día:</label>
                <span>{{ formatDate(meeting.date) }}</span>
              </div>
              <div class="col-12 col-md-4 my-2 flex-column d-flex">
                <label class="mb-0 color-gray-6 text-small">Hora:</label>
                <span>{{ getTimeFromDate(meeting.date) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="data.meetings.length > 5 && data.meetings.length != limitNumber"
      class="col-11 mt-3 text-center"
    >
      <action-button
        variant="outline-success custom-view-more"
        i="fas fa-chevron-down"
        @click="loadMore"
      >
        Ver más Reuniones
      </action-button>
    </div>
  </div>
</template>

<script>
import months from '@/utils/constants/months';
import ActionButton from 'ActionButton';
import moment from 'moment';
export default {
  name: 'UtaMeetings',
  components: {
    ActionButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Historial de Consulta',
        routes: [
          'Inicio',
          'Manejo de Solicitud de Asistencia Técnica de Ubicación del Estudiante',
        ],
      },
      limitNumber: 5,
      statusHistory: [],
      student: null,
    };
  },
  computed: {
    filteredItems() {
      return this.data.meetings.slice(0, this.limitNumber);
    },
  },

  methods: {
    formatDate(value) {
      const date = new Date(value).toLocaleDateString('es-ES').split('/');
      return `${date[0]}/${months[date[1] - 1]}/${date[2]}`;
    },
    getTimeFromDate(value) {
      return moment(value).format('HH:mm A');
    },

    async loadMore() {
      this.limitNumber = 5;
    },
  },
};
</script>

<style lang="scss" scoped>
.tag-badge {
  display: flex;
  align-items: center;
  padding-right: 1em;
  height: 26px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  margin-bottom: 10px;
}

.dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
}
.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  letter-spacing: 0;

  display: inline-block;
}
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.text-small {
  font-size: 0.875rem;
}
.info-panel {
  padding: 15px 10px 1px 20px;
  border-bottom: none;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}
.info-panel-container {
  display: flex;
  flex-flow: row wrap;
  padding: 0px 10px 1px 23px;
  .info-panel-item {
    flex: 1 0 25%;
    margin-bottom: 1.5em;
    float: left;
    box-sizing: border-box;
    padding-right: 10px;
    span {
      display: block;
      text-align: left;

      letter-spacing: 0px;
    }
    label {
      margin-top: 10px;
      text-align: left;
      font-size: 1rem;
      letter-spacing: 0px;

      line-height: 1.6em;
    }
  }
}
</style>
